import { FC } from "react";

import { SubSectionData } from "@/domain/view/components/datatable/datatable-types";
import { Row } from "@tanstack/react-table";

import { IndicatorListItem } from "../../../models/indicator-model";
import { IndicatorType } from "../../../models/indicator-type-model";
import { IndicatorTypeView } from "../../indicator-type-view";

export interface DatatableIndicatorTypeSubSectionHeaderProps {
  data: SubSectionData<IndicatorListItem>;
  currentRow: Row<SubSectionData<IndicatorListItem>>;
}

export const DatatableIndicatorTypeSubSectionHeader: FC<DatatableIndicatorTypeSubSectionHeaderProps> = ({
  data,
  currentRow,
}) => {
  const count = currentRow.subRows.length;

  return (
    <div className="flex h-full flex-row items-center justify-start gap-2 px-4">
      <div className="flex flex-row items-center justify-start gap-2  ">
        <IndicatorTypeView type={data.key as IndicatorType} className="h-3" />
        <span className="text-xs text-muted-foreground">{count}</span>
      </div>
      <div className="flex grow flex-row items-center pl-2">
        <div className="h-[1px] w-full bg-foreground/10" />
      </div>
    </div>
  );
};
